import { Controller } from "@hotwired/stimulus"

// 求人票を貼り付ける画面で、企業の扱い（既存に紐づける／新規登録）のラジオに合わせて入力欄を出し分ける。
// 選ばれていない側の入力は disabled にして送信しない。
// JS が動かない環境では両方の入力欄が並んだまま送信されるが、サーバは company_mode の値だけを見るため壊れない。
export default class extends Controller {
  static targets = ["radio", "panel"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.radioTargets.find((radio) => radio.checked)?.value
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.companyModePanel === selected
      panel.hidden = !active
      panel.querySelectorAll("input, select, textarea").forEach((field) => {
        field.disabled = !active
      })
    })
  }
}
